"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "3px",
    height: "8px",
    viewBox: "0 0 3 8"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "1.43 3.55271368e-15 2.618 3.55271368e-15 1.188 7.194 -3.88578059e-15 7.194"
  }));
};

exports["default"] = _default;